import { isIOS } from '@/utils/envDetect'

function setTitle(title) {
  // hack在微信等webview中无法修改document.title的情况
  document.title = title

  if (isIOS()) {
    const $iframe = document.createElement('iframe')

    $iframe.src = '//gzh.qq.com/favicon.ico'
    $iframe.style.display = 'none'
    $iframe.onload = () => {
      setTimeout(() => {
        document.body.removeChild($iframe)
      }, 0)
    }
    document.body.appendChild($iframe)
  }
}

/**
 * 设置标题
 *
 * Usage
 * 同步 v-title="'标题'"
 * 异步 v-title.async="title"
 */
export default {
  bind(el, binding) {
    const { expression, value, modifiers } = binding

    if (!modifiers.async) {
      const title = value === undefined ? expression : value
      setTitle(title)
    }
  },

  update(el, binding) {
    const { modifiers, value, oldValue } = binding
    if (modifiers.async && oldValue !== value) {
      setTitle(value)
    }
  },
}
